export default {
  Dashboard: {
    View: "dabd:r",
    Config: "dabd:e",
    Export: "dabd:ex",
  },
  CSAT: {
    ViewList: "csat:rb",
    Export: "csat:ex",
  },
  CSATCorp: {
    ViewList: "csatc:rb",
  },
  Schedule: {
    ViewList: "schd:rb",
    ViewDetail: "schd:r",
    Create: "schd:c",
    Update: "schd:e",
    Delete: "schd:d",
    ViewResultTable: "schd:rbr",
    ExportResultTable: "schd:exr",
    ViewDashboard: "schd:rbd",
    ExportDashboard: "schd:exd",
  },
  Schema: {
    ViewList: "schm:rb",
    ViewDetail: "schm:r",
    Create: "schm:c",
    Update: "schm:e",
    Delete: "schm:d",
    Export: "schm:ex",
    ViewResultTable: "schm:rbr",
    ExportResultTable: "schm:exr",
    ViewDashboard: "schm:rbd",
    ExportDashboard: "schm:exd",
  },
  Result: {
    ViewList: "rslt:rb",
    ViewDetail: "rslt:r",
  },
  SurveyLink: {
    ViewList: "svlk:rb",
  },
} as const;
